import React from 'react'
import { Typography, Box } from '@material-ui/core'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

export interface ReportCardQuestionProps {
  question: string
}

export const ReportCardQuestion: React.FC<ReportCardQuestionProps> = ({ question }) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
      <Box position="relative" ml={5}>
        <HelpOutlineIcon style={{ marginRight: 8, color: '#000', background: '#fff', border: 0, borderRadius: '50%', fontSize: '66px', position: 'absolute', top: -5, left: -54, zIndex: 2 }} />
        <Typography variant="h6" style={{ background: '#6b8e23', color: '#fff', borderRadius: 8, padding: '12px 16px', fontWeight: 600, position: 'relative', zIndex: 1 }}>
          {question}
        </Typography>
      </Box>
    </Box>
  )
}